import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tick",
  "use": "tick-usage",
  "viewBox": "0 0 11 9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 9\" id=\"tick\">\n    <path d=\"m9.417 0 1.414 1.414L3.8 8.445 0 4.645l1.414-1.414L3.8 5.617 9.417 0z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol